import * as _ from 'lodash';
import JsonApiReference from './jsonapi-reference';
import JsonApiRelationship from './jsonapi-relationship';
import BaseResource from './base-resource';

interface RelationshipMap {
  [name: string]: JsonApiRelationship;
}
class JsonApiResource extends JsonApiReference {
  links: any = {};
  attributes: any = {};
  relationships: RelationshipMap = {};

  constructor(init?: any) {
    super(init);

    this.id = init.id;
    this.type = init.type;
    this.attributes = init.attributes;

    _.each(init.relationships, (data, name) => {
      this.relationships[name] = new JsonApiRelationship(data);
    });
  }

  getReference(): JsonApiReference {
    return new JsonApiReference(this);
  }

  addAttribute(item: string | number | boolean, name: string) {
    this.attributes[name] = item;
  }

  addRelated(item: BaseResource, name: string) {
    this.relationships[name] = new JsonApiRelationship(item.packAsReference());
  }

  addRelatedArray(items: BaseResource[], name: string) {
    this.relationships[name] = new JsonApiRelationship(
      _.map(items, item => item.packAsReference())
    );
  }

  getRelated(name: string): JsonApiReference {
    const raw: any = _.get(this.relationships, name);

    if (_.isNil(raw.data)) return;

    return new JsonApiReference(raw.data);
  }

  getRelatedArray(name: string): JsonApiReference[] {
    const raw: any = _.get(this.relationships, name);
    let result: JsonApiReference[];
    if (raw.data instanceof Array) {
      result = raw.data.map(ref => new JsonApiReference(ref));
    } else if (!_.isNil(raw.data)) {
      result = [new JsonApiReference(raw.data)];
    } else {
      result = [];
    }

    return result;
  }
}

export default JsonApiResource;



// WEBPACK FOOTER //
// ./common/models/jsonapi-resource.ts